export default class OriginAndDestinationTableViewModel {
    origins: OriginAndDestinationViewModel[] = [];
    destinations: OriginAndDestinationViewModel[] = [];
}

class OriginAndDestinationViewModel {
    originOrDestination: string = '';
    frequency: number = 0;
}

